import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateCaseManage } from '../../../../../../services/CaseManagementService';

const Diagnosis2Field: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const handleDiagnosisChange = (value: string) => {
    if (!currentCase?.codingDetails?.diagnosisCodes) return;
    
    const updatedDiagnosisCodes = {
      ...currentCase.codingDetails.diagnosisCodes,
      diagnosis2: value
    };
    
    dispatch(updateCaseManage({
      codingDetails: {
        ...currentCase.codingDetails,
        diagnosisCodes: updatedDiagnosisCodes
      }
    }));
  };

  return (
    <Box sx={{ flex: 1 }}>
      <TextField
        label="Diagnosis 2"
        size="small"
        fullWidth
        value={currentCase?.codingDetails?.diagnosisCodes?.diagnosis2 || ''}
        onChange={(e) => handleDiagnosisChange(e.target.value)}
      />
    </Box>
  );
};

export default Diagnosis2Field;
